import { Action } from '@ngrx/store';
import { IExternalAppData } from '../models/externalAppData.model';

export enum ActionTypes {
    SET_INITIAL_DATA = '[External App Data] Set Initial Data',
    SET_ADVANCED_PAYMENT_DATA = '[External App Data] Set Advanced Payment Data',
    SET_REGULAR_PAYMENT_DATA = '[External App Data] Set Regular Payment Data',
    SET_FINANCIAL_VIEW = '[External App Data] Set Financial View',
    SET_FROM_REDIRECT = '[External App Data] Set From Redirect',
}

export class SetInitialData implements Action {
    readonly type: string  = ActionTypes.SET_INITIAL_DATA;

    constructor(public payload?: IExternalAppData) {}
}

export class SetAdvancedPaymentData implements Action {
    readonly type: string = ActionTypes.SET_ADVANCED_PAYMENT_DATA;

    constructor(public payload?: IExternalAppData) {}
}

export class SetRegularPaymentData implements Action {
    readonly type: string = ActionTypes.SET_REGULAR_PAYMENT_DATA;

    constructor(public payload?: IExternalAppData) {}
}

export class SetFinancialView implements Action {
  readonly type: string = ActionTypes.SET_FINANCIAL_VIEW;

  constructor(public payload?: string) {}
}

export class SetFromRedirect implements Action {
  readonly type: string = ActionTypes.SET_FROM_REDIRECT;

  constructor(public payload?: boolean) {}
}

export type Actions =
    | SetInitialData
    | SetAdvancedPaymentData
    | SetRegularPaymentData
    | SetFinancialView
    | SetFromRedirect;